import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import testimonials1 from "../img/testimonials1.webp";
import testimonials2 from "../img/testimonials2.webp";
import testimonials3 from "../img/testimonials3.webp";
import "../css/carouselTestimonials.css";

export default function CarouselTestimonials() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="carousel-container">
      <Slider {...settings}>
        <div>
          <img
            src={testimonials1}
            alt="Yacht repair service in Panama – customer testimonial"
          />
        </div>
        <div>
          <img
            src={testimonials2}
            alt="Panama marine support and boat maintenance – testimonial"
          />
        </div>
        <div>
          <img
            src={testimonials3}
            alt="Satisfied client after Panama yacht repair service"
          />
        </div>
      </Slider>
    </div>
  );
}
